interface FormErr {
    [key: string]: string | number;
    
  }

  type Input = {
    firstname: string,
    lastname: string,
    email: string,
    phone: string,
    quantity: string,
    message: string,
    "sample photo": string
  }

export const validate = (formvalues:FormErr)=>{
    const err:FormErr = {};
    for(let key in formvalues){
        if(!formvalues[key]){
            err[key] = `Your ${key} is required.`
        }
    }
    const pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    if((typeof formvalues.email == "string") && !pattern.test(formvalues.email)){
        err.email = "Please enter a valid email address."
    }
    const num = /^\d+$/
    if((typeof formvalues.quantity == "string") && formvalues.quantity && !num.test(formvalues.quantity)) {
        err.quantity = "Please enter a numeric value as Quantity."
    }else if(Number(formvalues.quantity) <= 0){
        err.quantity = "Please enter a value greater than zero."
    }
    return err;
  }

  export const isPosting = (values: Input) =>{
    const num = /^\d+$/;
    const pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return(
        values.email.length > 0 && values.firstname.length > 0 && values.lastname.length > 0 && values.phone.length > 0 && Number(values.quantity) > 0 && num.test(values.quantity) && pattern.test(values.email) && values["sample photo"].length > 0 && values.message.length > 0
    )
  }